import { type MenuItem, ProfileMenuGroup } from 'shared/types'

import { NightOwl } from '~/domains/platform/core/night-owl/night-owl'
import { type Entity } from '~/domains/platform/infra/deus-ex-machina/types'

import analitica from './analitica'

export function acquirerProfileMenu(entity: Entity): MenuItem[] {
  const isOneStone = entity?.stoneAccount?.situation === 'one_stone'

  // V2 (OneStone) liberado sempre; o legado mantém o scope antigo.
  const isResourceOwner = isOneStone || NightOwl.verifyScopes(['acquireraffiliation:transactionalkey:write'])

  return [
    {
      order: 9,
      label: 'Contas de recebimento',
      icon: 'bank',
      show: entity?.roles?.acquirer,
      onClick: () => {
        analitica.events.profileMenu.click('contas de recebimento')
      },
      path: '/contas-de-recebimento',
      active: (route: string) => ['/settings/receivable-accounts', '/contas-de-recebimento'].includes(route),
      group: ProfileMenuGroup.ACCOUNT_SETTINGS
    },
    {
      order: 5,
      label: 'Chaves de autenticação',
      icon: 'key',
      show: isResourceOwner,
      path: '/chaves-de-autenticacao',
      active: (route: string) => ['/settings/sak-keys', '/chaves-de-autenticacao'].includes(route),
      group: ProfileMenuGroup.ACCESS_SECURITY
    }
  ]
}
